import Vue from 'vue';
import VueProgressbar from 'vue-progressbar';

const options = {
    color: '#4285f4',
    failedColor: '#ea4335',
    thickness: '3px',
};

if (process.env.VUE_APP_ENV === 'heidiland') {
    options.color = '#ffffff';
} else if (process.env.VUE_APP_ENV === 'grf') {
    options.color = '#FFB70F';
}

Vue.use(VueProgressbar, options);
